const WebsiteDevelopment  = {
  "heroQuoteSection": {
      "enable": true,
      "title": "Growth MARKETING",
      "headline": "<strong>seamlessly organic marketing</strong> to make people tick.",
      "image": require('../images/digital/digital-1.png'),
      "position": "center", //center, left or rightM
      "btnGrad" : "green",
      "class" : "move-from-left"
  },
  "textWithImage":{
    "enable": true,
    "content": "<strong>Grow Your Business Online!</strong><br/><br/> Mobikasa offers go-to market and growth strategies to help you achieve your goals by combining the right strategies, forecasting results and timelines.",
    "image": require('../images/digital/digital-2.png'),
    "position": "right", //center, left or rightM
    "class" : "move-from-right",
    "button": {
        "text": "Contact Us Today",
        "url": "/get-quote",
        "class": "grad-green quote"
    }      
  }, 
  "iconsWithHeadingText": {
    "enable": true,
    "title": "What can we help you with",
    "subheading": "",
    "blocks":[
        {
            "src": require('../svgs/seo.svg'),
            "heading": "SEARCH ENGINE OPTIMIZATION",
            "content": "Search Engine Optimization (SEO) is about making your website as visible as possible on multiple search engines. Although, we wish it was as simple as it sounds."
        },
        {
            "src": require('../svgs/smm.svg'),
            "heading": "Social Media Management",
            "content": "Wondering which platform would be the right fit? Want to move forward and start generating engagement with your audience?"
        },
        {
            "src": require('../svgs/ppc.svg'),
            "heading": "PAY PER CLICK",
            "content": "The deepest, most desperate desire of any business owner’s heart is to get the best ‘Returns on Ad spends’ be it clicks, impressions or conversions."
        },
        {
            "src": require('../svgs/analytics.svg'),
            "heading": "ANALYTICS",
            "content": "We review your website using an advanced audit to find any issues. The audit includes an in-depth analysis of the web analytics configuration and tracking cross-references to your requisites."
        },
    ]
    },
    "faq":{
      "enable": true,
      "title": "Frequently asked questions",
      "questions": [
        {
          "key": 1,
          "q": "01 Earning traffic",
          "a": "Web development services range from front and back end development, e-commerce development, web app development, third party integrations and customizations, prototyping and UXD all the way to technical consultancy. The list is nearly endless. However, all of the previously stated services are worked on different platforms used for web design."
        },
        {
          "key": 2,
          "q": "Measurable advertising",
          "a": `Now of-course any business or brand can have their website developed in house. However, this in house development comes with a lot of issues. Listed below are the reasons why a professional web development agency should be hired for web development as opposed to having it all done in house.`
        },
        {
          "key": 3,
          "q": "Design that dazzles",
          "a": "Each platform has its own pros and cons. What’s best, depends on what your brand is looking for. Some platforms support more flamboyant designs while others are more suitable for content-based websites. Here at Mobikasa, we communicate with our clients to figure out exactly what they are looking for and what would work best for them. Our team of professionals possess expertise on all platforms, thus enabling us to find the best web development solution for our clients."
        },
        {
            "key": 4,
            "q": "Expand your social reach",
            "a": "Each platform has its own pros and cons. What’s best, depends on what your brand is looking for. Some platforms support more flamboyant designs while others are more suitable for content-based websites. Here at Mobikasa, we communicate with our clients to figure out exactly what they are looking for and what would work best for them. Our team of professionals possess expertise on all platforms, thus enabling us to find the best web development solution for our clients."
        }
      ]
    }
};

export default WebsiteDevelopment;